import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const SpiralShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 418.3 380.6",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M410.2 122.4c-8.9-25.1-26.4-51.2-52.1-77.5l-.8-.8C334.8 26.7 309.7 13 282.9 3.6c-.4-.1-.8-.3-1.3-.3-32.9-5.6-61.2-4-86.6 5-.3.1-.6.2-.8.3-23 11.1-46.7 22.6-67.6 40.1-.3.2-.5.4-.7.7-16.5 17.6-29.5 38.1-37.4 59.3-9 23.9-11.5 47.7-7.4 70.9 8.2 44 29.2 76.7 62.3 97.1l.1.1c21.2 12.5 42.6 19.6 63.6 21.4 22.1 1.8 43.9-2.4 64.8-12.5 32.6-15.8 55.8-44.2 62.1-75.9 7.3-28.8 1-61.2-17-86.6-16.9-23.9-41.1-38.3-68.3-40.8-.6-.1-1.2 0-1.7 0-17.9 2.3-42.9 8.7-60.3 25.7-7.8 7.6-17.3 19.9-20.8 29.9-5.3 15.2-3.6 31.6 4.8 46.2 9.6 16.4 25.8 27.9 44.5 31.7.5.1.9.1 1.4.1 17.9.2 32.1-7.3 36.3-19.2.4-1.2.5-2.4.4-3.7 0-1.7.3-3.4.8-5 1-4.1 2.6-10.2-1.1-16-3.4-5.3-10.1-8.5-21.6-10.4-4.4-.7-8.5 2.2-9.2 6.5-.7 4.4 2.2 8.5 6.5 9.2 7.4 1.3 9.9 2.7 10.6 3.2-.2 1.2-.4 2.3-.7 3.5-.8 2.8-1.3 5.6-1.4 8.5-2.3 3.8-9.5 7.3-19.7 7.4-13.8-3-25.8-11.6-32.9-23.8-6.1-10.5-7.3-22.2-3.6-33 2.5-7.1 10.5-17.5 16.9-23.7 7.8-7.6 22.9-17.4 50.3-21.2 22.1 2.2 41.9 14.3 55.8 34 15.3 21.7 20.7 49.2 14.5 73.6 0 .2-.1.3-.1.5-5.2 26.9-25.2 51.1-53.4 64.8-36 17.5-74.1 14.7-113.2-8.3-29-18-47.5-47-54.9-86.3-3.5-20.2-1.3-41.2 6.7-62.4 7.2-19.1 18.8-37.6 33.8-53.6 19.2-15.9 40.7-26.4 63.5-37.5 22.5-7.9 47.8-9.3 77.5-4.3 24.8 8.8 48 21.5 68.7 37.5 23.7 24.4 39.9 48.3 48 71 12 46.7 9.2 91.4-8.3 129.2-16.1 32.4-39.9 60.3-69.4 81.2-57.9 35.7-130.6 35.6-194.4-.1C56.7 300.7 15.8 234.1 16 164c0-4.5-3.5-8.1-8-8.2-4.4.1-8 3.7-8 8.1-.2 75.9 43.9 147.9 115 187.7 34.4 19.3 71.2 28.9 107.3 28.9 36.6.1 72.4-10 103.5-29.3.1-.1.3-.2.4-.3 31.8-22.5 57.4-52.6 74.7-87.4 0-.1.1-.1.1-.2 19.2-41.4 22.4-89.9 9.3-140.4 0-.1-.1-.3-.1-.5z"
    })
  });
};

export { SpiralShape };
//# sourceMappingURL=SpiralShape.js.map
